import styled from 'styled-components';
import { Paper } from '@material-ui/core';

export const StyledBatchUpdatePostsStatus = styled.div`
  h3 {
    margin-bottom: 0;
  }
`;

export const StyledContent = styled.div`
  margin: 2rem;

  .info-nav-button {
    white-space: nowrap;
  }
`;

export const StyledTitle = styled.h3`
  display: inline-block;
  width: 100%;
  font-size: 1.5rem;
  font-weight: 700;
  margin-bottom: 2rem;
`;

export const StyledTitleWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  margin-bottom: 2rem;
`;

export const StyledInfo = styled(Paper)`
  display: flex;
  padding: 2rem;
  align-items: center;
`;

export const StyledFooter = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 2rem 2rem 4rem 2rem;
`;
